/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ApplicationAliases {
  ACCESSIBILITY = 'accessibility',
  APPLICATION_BAR_BENEFICIARY = 'application-bar-beneficiary',
  AVATAR_USER = 'avatar-user',
  BREADCRUMB_0 = 'breadcrumb-0',
  BREADCRUMB_BODY = 'breadcrumb-body',
  DROP_DOWN_MENU_0 = 'drop-down-menu-0',
  DROP_DOWN_MESSAGE = 'drop-down-message',
  FETCH_NOTIFICACOES = 'fetch-notificacoes',
  FOOTER_0 = 'footer-0',
  FRAGMENT_0 = 'fragment-0',
  FRAGMENT_1 = 'fragment-1',
  FRAGMENT_BODY = 'fragment-body',
  LAYOUT_0 = 'layout-0',
  LAYOUT_1 = 'layout-1',
  LAYOUT_2 = 'layout-2',
  LAYOUT_APPLICATION = 'layout-application',
  LAYOUT_BODY = 'layout-body',
  LINK_MENSAGEM = 'link-mensagem',
  LINK_MOSTRAR_TODAS_MENSAGENS = 'link-mostrar-todas-mensagens',
  NOTIFICATION_CENTER = 'notification-center',
  OPTION_EXIT = 'option-exit',
  OPTION_MENSAGENS = 'option-mensagens',
  OPTION_MEUS_DADOS = 'option-meus-dados',
  PANEL_0 = 'panel-0',
  PANEL_1 = 'panel-1',
  PANEL_MENSAGENS = 'panel-mensagens',
  PANEL_MENSAGENS_RESUMO = 'panel-mensagens-resumo',
  PANEL_MOSTRAR_TODAS_MENSAGENS = 'panel-mostrar-todas-mensagens',
  PANEL_NOTIFICACOES = 'panel-notificacoes',
}
export { ApplicationAliases };
